export default "__VITE_ASSET__BWgYWPcv__"